import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    // debug: true,
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/assets/locales/{{lng}}.json`
    },
    lng: localStorage.getItem(process.env.REACT_APP_LOCALSTORAGE_LANGUAGE_KEY) || 'zh-TW',
    fallbackLng: false,
    load: 'currentOnly',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
